module.exports = __webpack_public_path__ + "img/banner.d640768b.png";